module.exports = __webpack_public_path__ + "static/image/history/pc/201707@3x.ver2_0_2.jpg?b3619a79";